import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { decryptData } from "../utils/helpers";

const PublicRoute = ({ children }) => {
  const token = Cookies.get("token");
  const enc = Cookies.get("admin_enc");

  let admin = null;
  if (enc) {
    try {
      admin = decryptData(enc);
    } catch (err) {
      // corrupted or invalid cookie
      admin = null;
    }
  }

  // If logged in → redirect to dashboard (your dashboard is '/')
  if (token && admin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PublicRoute;
